import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { LucideIconInput } from '@lucide/angular';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ptl-page-empty',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  templateUrl: './ptl-page-empty.component.html',
  styleUrls: ['./ptl-page-empty.component.scss'],
})
export class PtlPageEmptyComponent {
  title = input('');
  body = input('');
  ctaLabel = input('');
  ctaIcon = input<LucideIconInput | null>(null);
  /** Stretch to the parent's full width instead of the default 560px centered card. */
  fullWidth = input(false);
  ctaClicked = output<void>();
}
